import { useEffect, useState } from 'react'

import { useFirestore } from "../../../../hooks/useFirestore";
import { COLLECTION_PATH } from "../../../../firebase/FirebaseConst";

//COMPONENTS
import TaskEditor from './TaskEditor';


//STYLES && ICONS
import './AdminBarTasks.css'
import { useData } from '../../../../hooks/useData';
import { useCollection } from '../../../../hooks/useCollection';



export default function AdminBarTasks({rawTasks}) {

  // const { documents: rawTasks, error: collectionError } = useCollection(COLLECTION_PATH.TASKS.COLLECTION)
  const { batchDocuments, response } = useFirestore(COLLECTION_PATH.TASKS.COLLECTION)
  const [ isUpdated, setIsUpdated ] = useState(false)
  const [tasksToDelete, setTasksToDelete] = useState([])


  const [filteredTasks, setFilteredTarks] = useState(null)
  const [currentFilter, setCurrentFilter] = useState('1')

  const [localTasks, setLocalTasks] = useState(null)


  const handleFilter = (cat) => {
    setCurrentFilter( (prevCat) => {
      // Update localTasks, replacing each task from a given prevCat Category with the one in filtered task matching the id
      // const tasks = []
      // console.log("prev cat : ", prevCat)
      // localTasks.map( t => {
      //   if (t.catId == prevCat) {
      //     tasks.push(filteredTasks.filter(ft => ft.id === t.id)[0])
      //   } else {
      //     tasks.push(t)
      //   }
      // })
      // console.log(tasks)
      // setLocalTasks(tasks)

      // return thew new cat, which will reinit the current filter, and made the whole comopopenent reevaluated
      return cat
    })
  }
  
  useEffect( () => {
    if (response.error) {
      setIsUpdated(false)
    }
    if (rawTasks && !localTasks) { 
      setLocalTasks(rawTasks)  
    }
    if (isUpdated) {
      setLocalTasks(rawTasks)
    }
    if (localTasks && currentFilter) {
      const tasks = []
      localTasks.map( (t) => {
        if (t.catId === currentFilter) {
          tasks.push(t)
        } else {
          return
        }
      })
      tasks.sort((a, b) => {
        console.log('sorting filtered tasks')
        if (a.order < b.order) {
          return -1
        } else if (a.order > b.order) {
          return 1
        } else {
          return 0
        }
      })
      console.log(tasks)
      setFilteredTarks(tasks)
    }
  }, [rawTasks, localTasks, currentFilter, isUpdated, response])

  const addLocalTask = (task) => {
    setIsUpdated(false)
    console.log('add new task to local tasks, in order', task.order, ', and in cat ', task.catId)
    setLocalTasks(prev => [...prev, {...task, newTask:true}])
    setCurrentFilter(prev => prev)
  }

  const deleteLocalTask = (taskId) => {
    setIsUpdated(false)
    console.log('remove local task')
    setLocalTasks(prev => {
      const task = prev.find(pt => pt.id === taskId)
      //TODO UPDATE ORDERS !!
      prev.forEach(pt => {
        if (pt.order > task.order) {
          pt.order --
          pt.modified = pt.newTask ? false : true
        }
      });
      setTasksToDelete(prev => [...prev, task])
      return prev.filter(pt => pt.id !== taskId)
    })
  }

  const updateLocalTask = (task) => {
    setIsUpdated(false)
    console.log('Update local task')
    setLocalTasks(prev => {
      console.log("prev : ", prev)
      return prev.map( pt => {
        if (pt.id === task.id) {
          return {...task, modified: true }
        } else {
          return pt
        }
      })
    })
  }


  const moveLocalTask = (task, direction) => {
    setIsUpdated(false)
    let newTaskOrder = task.order
    switch (direction) {
      case 'up':
        newTaskOrder = task.order > 1 ? newTaskOrder -1 : newTaskOrder
        console.log('move the task up to order ', newTaskOrder)
        break;
      case 'down':
        newTaskOrder = task.order < filteredTasks.length ? newTaskOrder + 1 : newTaskOrder
        console.log('move the task down to order ', newTaskOrder)
        break;
      default:
        break;
    }
    setLocalTasks( prev => {
      return prev.map(pt => {
        if (pt.order === task.order && pt.catId === task.catId ){
          // TODDO add the task for later update
          return {...pt, order: newTaskOrder, modified: true}
        } else if (pt.order === newTaskOrder) {
          // TODDO add the task for later update
          return {...pt, order: task.order, modified: true}
        } else {
          return {...pt}
        }
      })
    })
  }

  const flushTasks = () => {
    console.log("Local tasks : " , localTasks)

    let updatedTasks = []
    let addedTasks = []

    localTasks.map(lt => {
      if(lt.modified && ! lt.newTask) {
        updatedTasks.push({
          id: lt.id,
          updates: {
            catId: lt.catId,
            contentBlocks: lt.contentBlocks,
            order: lt.order,
            title: lt.title
          }
        }) }
      else if (lt.newTask) {
        addedTasks.push({
          catId: lt.catId,
          contentBlocks: lt.contentBlocks,
          order: lt.order,
          title: lt.title
        })
      }
      return
    })

    console.log("Tasks to add : ", addedTasks)
    console.log("Tasks to update : ", updatedTasks)
    console.log("Tasks to delete : ", tasksToDelete)
    batchDocuments(addedTasks, updatedTasks, tasksToDelete)
    setIsUpdated(true)
  }

  return (
    <div>
      <h2>Gestion des Tâches</h2>
      <button className="btn block-btn" onClick={flushTasks}>Sauvegarder</button>
      {response && (<div className="info">
        {response.isPending && (<p>Is Pending</p>)}
        {response.error && (<p>Error : {response.error}</p>)}
        {response.succes && (<p>Succes ! {response?.document}</p>)}
      </div>)}

      <div className="tasks-list">
        <div className='select-container'>
          <button className="btn" onClick={() => handleFilter('1')}>Ouverture</button>
          <button className="btn" onClick={() => handleFilter('2')}>Fermeture</button>
          <button className="btn" onClick={() => handleFilter('3')}>Durant le shift</button>
          <button className="btn" onClick={() => handleFilter('4')}>Mots de passe</button>
        </div>
        { filteredTasks && filteredTasks.map( (t) => (
          <TaskEditor 
            key={t.id} 
            task={t} 
            saveTask={updateLocalTask} 
            moveTask={moveLocalTask}
            deleteTask={deleteLocalTask}/>
        ))}
        <TaskEditor 
          cat={currentFilter} 
          open={true} 
          newTask={true} 
          saveTask={addLocalTask} 
          order={filteredTasks ? filteredTasks.length + 1 : 1}/>

      
      </div>
    
    </div>
  )
}
